import cx from 'classnames'
import React from 'react'

import styles from './card.module.css'

interface Props {
  disabled?: boolean
  isHoverable?: boolean
  elevationLevel?: 'high' | 'normal'
}

const Card: React.FC<Props> = ({ disabled, isHoverable, elevationLevel, children }) => {
  return (
    <div
      className={cx(styles.card, {
        [styles.inactive]: disabled,
        [styles.hoverable]: isHoverable,
        [styles.highElevation]: elevationLevel === 'high',
      })}
    >
      {children}
    </div>
  )
}

export default Card
